import React from 'react'
import { Paper, Grid, Box, IconButton, TextField, Autocomplete, Select, MenuItem, FormControl, InputLabel, Typography } from '@mui/material'
import DeleteIcon from '@mui/icons-material/Delete'
import DragIndicatorIcon from '@mui/icons-material/DragIndicator'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import SelectReact from 'react-select'
import { customStyles } from '../../helpers/style'

export default function AutoCallTimeCard({ 
  timeItem, 
  index, 
  form, 
  setForm, 
  langIndex, 
  greenTheme, 
  inputStyles, 
  inputLabelStyles, 
  selectStyles, 
  auto, 
  short,
  weekDays, 
  input, 
  sip,
  isOrdered,
  inAuto,
  inAuto1,
  inAuto1SingleItem,
  files,
  isGroup,
  AutoSelect
}) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ 
    id: timeItem.id || index, 
    disabled: !isOrdered 
  })

  const style = {
    transition,
    transform: CSS.Transform.toString(transform),
    opacity: isDragging ? 0.5 : 1,
  }

  const handleTimeChange = (name, value) => {
    const updatedTime = [...form.time]
    updatedTime[index] = {
      ...updatedTime[index],
      [name]: value
    }
    setForm({ ...form, time: updatedTime })
  }

  const showDragHandle = isOrdered && !isGroup
  const contentXs = showDragHandle ? (form.time.length > 1 ? 10 : 11) : (form.time.length > 1 ? 11 : 12)
  const contentSm = showDragHandle ? (form.time.length > 1 ? 10 : 11) : (form.time.length > 1 ? 11 : 12)

  return (
    <Paper 
      ref={setNodeRef}
      style={style}
      sx={{ 
        p: isGroup ? 1.5 : 2,
        mb: isGroup ? 1 : 2,
        border: `1px solid ${greenTheme.primary}26`,
        color: 'rgba(65, 63, 29, 0.87)',
        boxShadow: isGroup ? 'none' : 'rgba(0, 0, 0, 0.12) 0px 3px 10px -2px, rgba(0, 0, 0, 0.08) 0px 2px 4px 0px',
        transition: 'box-shadow 200ms ease, border-color 200ms ease, transform 200ms ease',
        borderRadius: 2,
        backgroundColor: '#f9fafb',
        position: 'relative',
        zIndex: isDragging ? 1000 : 1,
        ...(isGroup && {
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          gap: 2,
          flexWrap: 'nowrap',
        }),
        '&:hover': {
          boxShadow: isGroup ? 'none' : 'rgba(0, 0, 0, 0.16) 0px 10px 22px -8px, rgba(0, 0, 0, 0.10) 0px 4px 10px 0px',
          borderColor: `${greenTheme.primary}55`,
        },
      }}
    >
      {isGroup && form.time.length > 1 && (
        <IconButton
          size="small"
          onClick={() => {
            const updatedTime = form.time.filter((_, i) => i !== index)
            setForm({ ...form, time: updatedTime })
          }}
          sx={{
            flexShrink: 0,
            color: '#ef4444',
            '&:hover': {
              backgroundColor: 'rgba(239, 68, 68, 0.1)',
            },
          }}
          aria-label="Remove time configuration"
        >
          <DeleteIcon sx={{ fontSize: 20 }} />
        </IconButton>
      )}
      <Grid container spacing={isGroup ? 2 : 3} alignItems="flex-start" sx={isGroup ? { flex: 1, minWidth: 0 } : {}}>
        {showDragHandle && (
          <Grid item xs={1} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Box
              component="span"
              {...attributes}
              {...listeners}
              sx={{
                cursor: isOrdered ? 'grab' : 'default',
                '&:active': {
                  cursor: 'grabbing',
                },
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                touchAction: 'none',
                userSelect: 'none',
                WebkitUserSelect: 'none',
              }}
            >
              <IconButton
                size="small"
                sx={{
                  color: greenTheme.primary,
                  pointerEvents: 'none',
                }}
                aria-label="Drag to reorder"
              >
                <DragIndicatorIcon sx={{ fontSize: 20 }} />
              </IconButton>
            </Box>
          </Grid>
        )}
        <Grid 
          item 
          xs={contentXs} 
          sm={contentSm}
          sx={isGroup ? { flex: 1, minWidth: 0 } : undefined}
        >
          <Box sx={{ '& .select__control': { minHeight: 40 }, ...(isGroup && { minWidth: 0 }) }}>
            {isGroup ? (
              <SelectReact
                styles={customStyles}
                value={inAuto1SingleItem?.find(k => k.name === timeItem.num) ? { value: timeItem.num, label: inAuto1SingleItem.find(k => k.name === timeItem.num)?.title || timeItem.num } : null}
                menuPlacement="auto"
                menuPosition="fixed"
                onChange={(ev) => handleTimeChange('num', ev ? ev.value : '')}
                menuPortalTarget={document.body}
                className="basic-single"
                classNamePrefix="select"
                options={(inAuto1SingleItem || []).map(k => ({ value: k.name, label: k.title || k.name }))}
                placeholder={input.select[langIndex]}
              />
            ) : (
              <SelectReact
                styles={customStyles}
                value={timeItem.num ? { value: timeItem.num, label: timeItem.num } : null}
                menuPlacement="auto"
                menuPosition="fixed"
                onChange={(ev) => handleTimeChange('num', ev ? ev.value : '')}
                menuPortalTarget={document.body}
                className="basic-single"
                classNamePrefix="select"
                options={[
                  {label:"IVR", options: inAuto?.map(k => ({value:k.name,label:k.title})) || []},
                  {label:"SHORT", options: inAuto1?.map(k => ({value:k.name,label:k.title})) || []}
                ]}
                formatGroupLabel={(d) => AutoSelect ? <AutoSelect data={d}/> : d.label}
                placeholder={input.select[langIndex]}
              />
            )}
          </Box>
        </Grid>
        {!isGroup && form.time.length > 1 && (
          <Grid item xs={12} sm={1} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
            <IconButton
              size="small"
              onClick={() => {
                const updatedTime = form.time.filter((_, i) => i !== index)
                setForm({ ...form, time: updatedTime })
              }}
              sx={{
                color: '#ef4444',
                '&:hover': {
                  backgroundColor: 'rgba(239, 68, 68, 0.1)',
                },
              }}
              aria-label="Remove time configuration"
            >
              <DeleteIcon sx={{ fontSize: 22 }} />
            </IconButton>
          </Grid>
        )}
        {!isGroup && (
          <>
        <Grid item xs={12} sm={6}>
          <FormControl fullWidth size="small">
            <InputLabel sx={inputLabelStyles}>
              {short.week[langIndex]} Start
            </InputLabel>
            <Select
              size="small"
              value={timeItem.weekStart || ''}
              onChange={(e) => handleTimeChange('weekStart', e.target.value)}
              label={`${short.week[langIndex]} Start`}
              sx={selectStyles}
            >
              <MenuItem value="">
                <em>{input.select[langIndex]}</em>
              </MenuItem>
              {weekDays.map((day, dayIndex) => (
                <MenuItem key={dayIndex} value={day[langIndex]}>
                  {day[langIndex]}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormControl fullWidth size="small">
            <InputLabel sx={inputLabelStyles}>
              {short.week[langIndex]} End
            </InputLabel>
            <Select
              size="small"
              value={timeItem.weekEnd || ''}
              onChange={(e) => handleTimeChange('weekEnd', e.target.value)}
              label={`${short.week[langIndex]} End`}
              sx={selectStyles}
            >
              <MenuItem value="">
                <em>{input.select[langIndex]}</em>
              </MenuItem>
              {weekDays.map((day, dayIndex) => (
                <MenuItem key={dayIndex} value={day[langIndex]}>
                  {day[langIndex]}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
            <Typography variant="body2" sx={{ minWidth: '80px', fontWeight: 500, color: '#64748b' }}>
              {short.time[langIndex]} Start:
            </Typography>
            <FormControl size="small" sx={{ flex: 1 }}>
              <Select
                size="small"
                value={timeItem.timeStart?.split(':')[0] || ''}
                onChange={(e) => {
                  const currentMinute = timeItem.timeStart?.split(':')[1] || '00'
                  handleTimeChange('timeStart', `${e.target.value}:${currentMinute}`)
                }}
                displayEmpty
                sx={selectStyles}
              >
                <MenuItem value=""><em>HH</em></MenuItem>
                {Array.from({ length: 24 }, (_, i) => (
                  <MenuItem key={i} value={String(i).padStart(2, '0')}>
                    {String(i).padStart(2, '0')}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <Typography variant="body2" sx={{ mx: 0.5 }}>:</Typography>
            <FormControl size="small" sx={{ flex: 1 }}>
              <Select
                size="small"
                value={timeItem.timeStart?.split(':')[1] || ''}
                onChange={(e) => {
                  const currentHour = timeItem.timeStart?.split(':')[0] || '00'
                  handleTimeChange('timeStart', `${currentHour}:${e.target.value}`)
                }}
                displayEmpty
                sx={selectStyles}
              >
                <MenuItem value=""><em>MM</em></MenuItem>
                {Array.from({ length: 60 }, (_, i) => (
                  <MenuItem key={i} value={String(i).padStart(2, '0')}>
                    {String(i).padStart(2, '0')}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
            <Typography variant="body2" sx={{ minWidth: '80px', fontWeight: 500, color: '#64748b' }}>
              {short.time[langIndex]} End:
            </Typography>
            <FormControl size="small" sx={{ flex: 1 }}>
              <Select
                size="small"
                value={timeItem.timeEnd?.split(':')[0] || ''}
                onChange={(e) => {
                  const currentMinute = timeItem.timeEnd?.split(':')[1] || '00'
                  handleTimeChange('timeEnd', `${e.target.value}:${currentMinute}`)
                }}
                displayEmpty
                sx={selectStyles}
              >
                <MenuItem value=""><em>HH</em></MenuItem>
                {Array.from({ length: 24 }, (_, i) => (
                  <MenuItem key={i} value={String(i).padStart(2, '0')}>
                    {String(i).padStart(2, '0')}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <Typography variant="body2" sx={{ mx: 0.5 }}>:</Typography>
            <FormControl size="small" sx={{ flex: 1 }}>
              <Select
                size="small"
                value={timeItem.timeEnd?.split(':')[1] || ''}
                onChange={(e) => {
                  const currentHour = timeItem.timeEnd?.split(':')[0] || '00'
                  handleTimeChange('timeEnd', `${currentHour}:${e.target.value}`)
                }}
                displayEmpty
                sx={selectStyles}
              >
                <MenuItem value=""><em>MM</em></MenuItem>
                {Array.from({ length: 60 }, (_, i) => (
                  <MenuItem key={i} value={String(i).padStart(2, '0')}>
                    {String(i).padStart(2, '0')}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            size="small"
            label={auto.phone[langIndex]}
            value={timeItem.phone || ''}
            onChange={(e) => handleTimeChange('phone', e.target.value)}
            sx={inputStyles}
            InputLabelProps={{ sx: inputLabelStyles }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            size="small"
            label={auto.attempt[langIndex]}
            value={timeItem.attempt || ''}
            onChange={(e) => handleTimeChange('attempt', e.target.value)}
            type="number"
            sx={inputStyles}
            InputLabelProps={{ sx: inputLabelStyles }}
          />
        </Grid>
          </>
        )}
      </Grid>
    </Paper>
  )
}

